


































import Vue from 'vue';

export default Vue.extend({
  name: 'FieldRadioList',
  props: {
    name: { type: String },
    label: { type: String },
    options: {
      type: [Object, Array],
    },
    optionsType: {
      type: Number,
      default: 1,
    },
    value: [Number, String],
    hint: { type: String },
    inline: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: function (value) {
      this.values = value;
    },
  },
  mounted(): void {
    this.values = this.value;
  },
  computed: {
    getName(): string {
      return this.name.replace('[', '-').replace(']', '').toLowerCase();
    },
    issetLabel(): boolean {
      return this.label !== '';
    },
    error(): string {
      return this.errors.join(', ');
    },
  },
  methods: {
    input() {
      this.$emit('input', this.values.toString());
    },
    change() {
      this.$emit('change', this.values.toString());
    },
    getId(value: string): string {
      return (
        'checkbox-' +
        this.getName +
        '-' +
        value.toString().replace('[', '-').replace(']', '').toLowerCase()
      );
    },
  },
  data: function () {
    return {
      values: '' as string | number,
    };
  },
});
